import { defineStore } from 'pinia'
import type { postCategory, Post  } from '~/types/general'

export const usePostStore = defineStore({
    id: 'post',
    state: () => ({
        categories: [{
            title: "Support",
            slug: "support",
            id: 1
        },
        {
            title: "Work With Us",
            slug: "work-with-us",
            id: 2
        },
        {
            title: "Company",
            slug: "company",
            id: 3
        }],

        page: [
            {
                title: "About Us",
                description: "content of the about us",
                category: "company",
                category_id: 3,
                slug: "about-us"
            }, //{
            //     title: "Careers",
            //     description: "content of the page carrers",
            //     category: "company",
            //     category_id: 3,
            //     slug: "careers"
            // },
            // {
            //     title: "Help Center",
            //     description: "content of the page contact us",
            //     category: "support",
            //     category_id: 1,
            //     slug: "help-center"
            // },
            {
                title: "Contact Us",
                description: "content of the page FAQ",
                category: "support",
                category_id: 1,
                slug: "contact-us"
            },
            // {
            //     title: "Privacy Policy",
            //     description: "content of the page shipping",
            //     category: "support",
            //     category_id: 1,
            //     slug: "privacy-policy"
            // },
            {
                title: "Terms and Condition",
                description: "",
                category: "support",
                category_id: 1,
                slug: "term-and-condition"
            },
            
            // generate content for category Work With Us
            // {
            //     title: "Affiliate Program",
            //     description: "content of the page affiliate program",
            //     category: "work-with-us",
            //     category_id: 2,
            //     slug: "affiliate-program"
            // },
            // {
            //     title: "Influencer Program",
            //     description: "content of the page influencer program",
            //     category: "work-with-us",
            //     category_id: 2,
            //     slug: "influencer-program"
            // },
            // {
            //     title: "Partner Program",
            //     description: "content of the page partner program",
            //     category: "work-with-us",
            //     category_id: 2,
            //     slug: "partner-program"
            // },
            // {
            //     title: "Wholesale Program",
            //     description: "content of the page wholesale program",
            //     category: "work-with-us",
            //     category_id: 2,
            //     slug: "wholesale-program"
            // }
        ]
    }),

    getters: {
        getCategories(): postCategory[] {
            return this.categories
        },

        getSupportPages(): Post[] {
            return this.page.filter(item => item.category === 'support');
        },

        getWorkWithUsPages(): Post[] {
            return this.page.filter(item => item.category === 'work-with-us');
        },

        getCompanyPages(): Post[] {
            return this.page.filter(item => item.category === 'company');
        },
    },
    actions: {
       
    }

})

